module.exports = __webpack_public_path__ + "img/1f98e.2d88a8c.svg";